import { render, staticRenderFns } from "./StyleEditTabEmbellishments.vue?vue&type=template&id=4396c4ec&"
import script from "./StyleEditTabEmbellishments.vue?vue&type=script&lang=js&"
export * from "./StyleEditTabEmbellishments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports